'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowLeftIconIcon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../lib/Icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeftIconIcon = exports.ArrowLeftIconIcon = function ArrowLeftIconIcon(props) {
  var _prepareProps = (0, _Icon.prepareProps)(props),
      title = _prepareProps.title,
      iconProps = _prepareProps.iconProps;

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, iconProps, { 'aria-labelledby': 'title-242baw6' }),
    _react2.default.createElement(
      'title',
      { id: 'title-242baw6' },
      title
    ),
    _react2.default.createElement('path', { d: 'M10.297 4.292L3.298 11.29a.998.998 0 0 0-.298.712c0 .257.097.514.291.71.003 0 .006.002.008.004l6.995 6.995a1 1 0 0 0 1.414-1.414l-5.294-5.295H20c.55 0 1-.45 1-1 0-.549-.45-.998-1-.998H6.414l5.297-5.298a1.003 1.003 0 0 0 0-1.415 1 1 0 0 0-.708-.29.994.994 0 0 0-.706.29z', fill: 'currentColor', fillRule: 'evenodd', role: 'presentation' })
  );
};
exports.default = (0, _Icon.iconConstructor)('ArrowLeftIcon', ArrowLeftIconIcon);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/icon/glyph/arrow-left.js
// module id = 349
// module chunks = 0